<template>
  <v-card class="px-2 pt-2" flat>

    <v-row>
      <v-col class="d-inline-flex">
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.departure')"
              :value="departureLabel"
              :icon="'mdi-map-marker-outline'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.arrival')"
              :value="arrivalLabel"
              :icon="'mdi-map-marker-outline'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.company')"
              :value="timetable.sender?.name"
              :icon="'mdi-account-arrow-right'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.booking')"
              :value="timetable.messageId"
              :icon="'mdi-file'"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col class="d-inline-flex">
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.statusDateTime')"
              :value="formatDateShort(timetable.statusDateTime)"
              :icon="'mdi-calendar'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.closingOfBooking')"
              :value="formatDateShort(timetable.closingOfBooking)"
              :icon="'mdi-calendar-lock'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.closingOfAcceptance')"
              :value="formatDateShort(timetable.closingOfAcceptance)"
              :icon="'mdi-calendar-check'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.closingOfLoading')"
              :value="formatDateShort(timetable.closingOfLoading)"
              :icon="'mdi-calendar-arrow-right'"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col class="d-inline-flex">

        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.trainNumber')"
              :value="timetable.trainNumber"
              :icon="'mdi-train'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.trainStatus')"
              :value="timetable.trainStatus"
              :icon="'mdi-train'"
          />
        </v-col>
        <v-col class="pa-0">
          <ReadonlyField
              :label="$t('label.trainType')"
              :value="timetable.trainType"
              :icon="'mdi-train'"
          />
        </v-col>
        <v-col class="pa-0"/>
      </v-col>
    </v-row>

    <v-divider class="mt-2 mb-0"/>

    <v-data-table
        :headers="transitHeaders"
        :items="timetable.transitEntryList || []"
        :items-per-page="1000"
        hide-default-footer
        class="pa-0"
        dense
    >
      <template slot="no-data">
        <v-icon color="warning" class="mr-1" size="20">mdi-alert</v-icon>
        <span class="font-weight-medium warning--text">
          {{ $t('label.noTrackingInfo') }}
        </span>
      </template>

      <template v-slot:item.eventDateTime="{ item }">
        {{ formatDateShort(item.eventDateTime) }}
      </template>
    </v-data-table>

  </v-card>
</template>

<script>
import Tracking from '@/mixins/Tracking'
import ReadonlyField from '@/components/elements/ReadonlyField.vue'

export default {
  name: 'RailTimetableDetail',
  props: ['timetable'],
  mixins: [Tracking],
  components: {ReadonlyField},
  data() {
    return {
      transitHeaders: [
        {text: this.$t('label.country'), value: 'countryIsoCode'},
        {text: this.$t('label.locationCode'), value: 'locationCode'},
        {text: this.$t('label.locationName'), value: 'locationName'},
        {text: this.$t('label.dateTime'), value: 'eventDateTime'},
      ],
    }
  },
  computed: {
    departureLabel() {
      const t = this.timetable
      const terminal = t.originTerminal?.terminalLocationName || t.originTerminal?.terminalName || ''
      const date = this.formatDateShort(t.trainDeparture)
      return terminal && date ? `${terminal} - ${date}` : terminal || date || null
    },
    arrivalLabel() {
      const t = this.timetable
      const terminal = t.destinationTerminal?.terminalLocationName || t.destinationTerminal?.terminalName || ''
      const date = this.formatDateShort(t.trainArrival)
      return terminal && date ? `${terminal} - ${date}` : terminal || date || null
    },
  },
}
</script>
